import React from 'react';
import FormSelect from "../FormSelect";
import i18n from "../../../i18n";
import FormNumber from "../FormNumber";
import {withStyles} from "@material-ui/core";

const FormIntervalFields = ({
    intervalUnits,
    values,
    classes,
    handleBlur,
    handleChange,
    touched,
    setFieldValue,
    ...props
}) => {
    return (<React.Fragment>
        <div className={classes.formInterval}>
            <FormNumber
                type="text"
                name="interval_value"
                decimalScale={0}
                className={classes.inputInterval}
                label={i18n.get('attribute.form.interval')}
                onChange={({target}) => {
                    setFieldValue("interval", target.value);
                    setFieldValue("interval_value", target.value);
                }}
                onBlur={handleBlur}
                value={values.interval_value}
                touched={touched.interval_value}
            />
            <FormSelect
                name="interval_unit"
                className={classes.inputInterval}
                label={i18n.get('attribute.form.interval_unit')}
                // error={errors.interval_unit}
                // touched={touched.interval_unit}
                onChange={({value, label}) => setFieldValue("interval_unit", value)}
                onBlur={handleBlur}
                options={intervalUnits && intervalUnits.map((value) => ({label: value.name, value: value.unit}))}
                value={values.interval_unit}
            />
        </div>
    </React.Fragment>
)};

const styles = theme => ({
    formInterval: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        width: '100%',
    },
    inputInterval: {
        flex: 1,
    },
});

export default withStyles(styles)(FormIntervalFields);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Form/Partials/IntervalFields.js